'use strict';

var required = require('./_required');

module.exports = function(name) {
  if (name === './jsforce' || name === 'jsforce') {
    name = './core';
  }
  var m = required[name];
  if (typeof m === 'undefined') {
    throw new Error("Cannot find module '" + name + "'");
  }
  return m;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsforce/lib/require.js
// module id = 107g
// module chunks = 0